<template>
    <div class="news" id="news">
        <div class="mobiletopbox hidden-sm-and-up">
            <div class="mobiletopbox_top">
                <div class="navigation">
                    <div class="navigation_location"></div>
                    <div class="navigation_index" @click="goIndex">首页</div>
                    <div class="navigation_img"></div>
                        <div class="navigation_text">你问我答</div>
                </div>
            </div>
        </div>
        <div class="news_box section">
            <div class="news_right" v-loading="loading">
                <div class="news_right_top hidden-xs-only">
                    <div class="navigation">
                        <div class="navigation_location"></div>
                        <div class="navigation_text">当前所在位置：</div>
                        <div class="navigation_index" @click="goIndex">首页</div>
                        <div class="navigation_img"></div>
                        <div class="navigation_text">你问我答</div>
                    </div>
                </div>
                <div class="news_right_bottom">
                    <div class="news_right_bottom_box" v-if="questionPage.length>0">
                        <div class="news_right_bottom_item" @click="openItem(item.id)" :class="idList.includes(item.id)?'news_right_bottom_item_active':''" v-for="(item,index) in questionPage" :key="index">
                            <div class="news_right_bottom_item_box">
                                <div class="news_right_bottom_item_top">
                                    <div class="news_right_bottom_item_top_left">
                                        <div class="news_right_bottom_item_top_left_img">
                                            <img src="../assets/images/common/answer_4.png" alt="">
                                        </div>
                                        <div class="news_right_bottom_item_top_left_name">{{item.question}}</div>
                                    </div>
                                    <div class="news_right_bottom_item_top_right">
                                        <img class="open_img" v-if="idList.includes(item.id)" src="../assets/images/common/answer_2.png" alt="">
                                        <img class="close_img" v-else src="../assets/images/common/answer_1.png" alt="">
                                    </div>
                                </div>
                                <transition name="slide-fade">
                                    <div class="news_right_bottom_item_content" v-if="idList.includes(item.id)">
                                        <div class="news_right_bottom_item_bottom">
                                            <div class="news_right_bottom_item_bottom_left">
                                                <img src="../assets/images/common/answer_5.png" alt="">
                                            </div>
                                            <div class="news_right_bottom_item_bottom_right">{{item.answer}}</div>
                                        </div>
                                    </div>
                                </transition>
                            </div>
                        </div>
                    </div>
                    <div class="news_right_bottom_none" v-if="questionPage.length == 0">暂无数据</div>
                    <!-- 分页 -->
                    <el-pagination
                        :current-page="query.current"
                        :page-size="query.pageSize"
                        @current-change="handleCurrentChange"
                        background
                        :total="total"
                        :pager-count="5"
                        layout="prev, pager, next">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { questionPage } from '../untils/common-api.js'
export default {
    data() {
        return {
            baseUrl: process.env.VUE_APP_BASE_URL,
            loading: false,
            total: null,
            idList:[],
            query: {
                current: 1,
                pageSize: 8,
                lang:1
            },
            questionPage: []
        }
    },
    created() {
        this.getQuestionPage()
        if(this.$route.query.id) {
            this.idList.push(Number(this.$route.query.id))
        }
    },
    mounted() {
        this.getScrollTop()
    },
    methods:{
        // 获取你问我答列表
        async getQuestionPage() {
            this.loading = true // loading start
            let res = await questionPage(this.query)
            this.loading = false // loading end
            if (res.code !== 1) return this.$message('信息获取失败，请稍后重试')
            this.total = res.data.total
            this.questionPage = res.data.records
        },
        handleCurrentChange(data) {
            this.query.current = data
            this.getQuestionPage()
            this.getScroll()
        },
        // 展开，折叠
        openItem(id) {
            // 判断id是否在idList中,存在就删除,不存在就添加
            if(this.idList.includes(id)){
                this.idList.splice(this.idList.indexOf(id),1)
            }else{
                this.idList.push(id)
            }
        },
        goIndex() {
            this.$router.push('/index')
        },
        handleTime(time) {
            if(time) {
                let year = time.substring(0,4);
                let month = time.substring(5,7);
                let day = time.substring(8,10);
                let timeStr = year+'.'+month+'.'+day
                return timeStr;
            }
        },
        getScroll() {
            let div = document.getElementById('news');
            if (div) {
                setTimeout(function () {
                    $('html, body').animate({scrollTop: 0}, 600)
                }, 500);
            }
        },
        getScrollTop() {
            let div = document.getElementById('news');
            if (div) {
                setTimeout(function () {
                    $('html, body').animate({scrollTop: 0}, 0)
                }, 0);
            }
        },
    },
}
</script>
<style lang="less" scoped>
.news {
    background-color: #f6f9ff;
    padding: 30px 0 80px 0;
    .news_box {
        .news_right {
            width: 100%;
            .news_right_top {
                margin-bottom: 20px;
            }
            .news_right_bottom {
                .news_right_bottom_box {
                    margin-bottom: 80px;
                    .news_right_bottom_item {
                        width: 100%;
                        padding: 0 25px;
                        display: flex;
                        cursor: pointer;
                        border-bottom: 1px solid #E3E3E3;
                        .news_right_bottom_item_box {
                            width: 100%;
                            .news_right_bottom_item_top {
                                width: 100%;
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                padding: 40px 0 ;
                                .news_right_bottom_item_top_left {
                                    width: calc(100% - 22px - 30px);
                                    display: flex;
                                    align-items: center;
                                    .news_right_bottom_item_top_left_img{
                                        margin-right: 20px;
                                        width: 30px;
                                        img {
                                            width: 30px;
                                            height: 30px;
                                        }
                                    }
                                    .news_right_bottom_item_top_left_name {
                                        width: calc(100% - 30px - 20px);
                                        font-size: 20px;
                                        font-weight: bold;
                                        text-align: justify;
                                    }
                                }
                                .news_right_bottom_item_top_right {
                                    display: flex;
                                    align-items: center;
                                    width: 22px;
                                    height: 22px;
                                    transition: transform 0.3s ease;
                                    .close_img {
                                        width: 22px;
                                        height: 22px;
                                        transition: all 0.3s ease;
                                    }
                                    .open_img {
                                        width: 22px;
                                        height: 2px;
                                        transition: all 0.3s ease;
                                    }
                                }
                            }
                            .news_right_bottom_item_content {
                                overflow: hidden;
                                .news_right_bottom_item_bottom {
                                    width: 100%;
                                    display: flex;
                                    padding: 40px 0;
                                    .news_right_bottom_item_bottom_left {
                                        margin-right: 20px;
                                        width: 30px;
                                        img {
                                            width: 30px;
                                            height: 30px;
                                        }
                                    }
                                    .news_right_bottom_item_bottom_right {
                                        width: calc(100% - 30px - 20px);
                                        font-size: 16px;
                                        color: #787878;
                                        line-height: 2;
                                        opacity: 0;
                                        transform: translateY(-10px);
                                        transition: all 0.3s ease;
                                        text-align: justify;
                                    }
                                }
                            }
                        }
                    }
                    .news_right_bottom_item_active {
                        border-bottom: none;
                        background-color: #ffffff;
                        box-shadow: 0px 0px 14px 0px rgba(29,47,71,0.14); 
                        .news_right_bottom_item_box {
                            .news_right_bottom_item_top {
                                background-color: #ffffff;
                                border-bottom: 1px solid #E3E3E3;
                                .news_right_bottom_item_top_right {
                                    transform: rotate(180deg);
                                }
                            }
                            .news_right_bottom_item_content {
                                .news_right_bottom_item_bottom {
                                    padding: 40px 0;
                                    .news_right_bottom_item_bottom_right {
                                        opacity: 1;
                                        transform: translateY(0);
                                        transition-delay: 0.1s;
                                    }
                                }
                            }
                        }
                    }
                    .news_right_bottom_item:hover {
                        box-shadow: 0px 0px 14px 0px rgba(29,47,71,0.14); 
                        .news_right_bottom_item_right {
                            .news_right_bottom_item_right_top {
                                color: #0085D0;
                                text-decoration: underline;
                                text-underline-offset: 3px;
                            }
                        }
                    }
                }
                // 使用Vue的transition实现高度动画
                .slide-fade-enter-active,
                .slide-fade-leave-active {
                    transition: all 0.4s ease;
                    overflow: hidden;
                }
                
                .slide-fade-enter,
                .slide-fade-leave-to {
                    max-height: 0;
                    opacity: 0;
                    transform: translateY(-20px);
                }
                .slide-fade-enter-to,
                .slide-fade-leave {
                    max-height: 500px;
                    opacity: 1;
                    transform: translateY(0);
                }
                .news_right_bottom_none {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: #ffffff;
                    min-height: 200px;
                    font-size: 16px;
                    margin-bottom: 60px;
                }
            }
        }
    }
}
@media (max-width: 768px) {
    .news {
        padding: 0.3rem 0 0.6rem 0;
        .news_box {
            .news_right {
                width: 100%;
                .news_right_bottom {
                    padding-top: 0.2rem;
                    .news_right_bottom_box {
                        margin-bottom: 0.6rem;
                        .news_right_bottom_item {
                            width: 100%;
                            padding: 0 0.2rem;
                            .news_right_bottom_item_box {
                                width: 100%;
                                .news_right_bottom_item_top {
                                    padding: 0.4rem 0 ;
                                    .news_right_bottom_item_top_left {
                                        width: calc(100% - 0.3rem - 0.2rem);
                                        .news_right_bottom_item_top_left_img{
                                            margin-right: 0.15rem;
                                            width: 0.5rem;
                                            img {
                                                width: 0.5rem;
                                                height: 0.5rem;
                                            }
                                        }
                                        .news_right_bottom_item_top_left_name {
                                            width: calc(100% - 0.5rem - 0.15rem);
                                            font-size: 0.3rem;
                                        }
                                    }
                                    .news_right_bottom_item_top_right {
                                        width: 0.3rem;
                                        height: 0.3rem;
                                        .close_img {
                                            width: 0.3rem;
                                            height: 0.3rem;
                                        }
                                        .open_img {
                                            width: 0.3rem;
                                            height: 0.02rem;
                                        }
                                    }
                                }
                                .news_right_bottom_item_content {
                                    .news_right_bottom_item_bottom {
                                        padding: 0.4rem 0;
                                        .news_right_bottom_item_bottom_left {
                                            margin-right: 0.15rem;
                                            width: 0.5rem;
                                            img {
                                                width: 0.5rem;
                                                height: 0.5rem;
                                            }
                                        }
                                        .news_right_bottom_item_bottom_right {
                                            width: calc(100% - 0.5rem - 0.15rem);
                                            font-size: 0.28rem;
                                            color: #787878;
                                            line-height: 1.6;
                                            transform: translateY(0);
                                        }
                                    }
                                }
                            }
                        }
                        .news_right_bottom_item_active {
                            .news_right_bottom_item_box {
                                .news_right_bottom_item_content {
                                    .news_right_bottom_item_bottom {
                                        padding: 0.4rem 0;
                                    }
                                }
                            }
                        }
                    }
                    .slide-fade-enter,
                    .slide-fade-leave-to {
                        max-height: 0;
                        opacity: 0;
                        transform: translateY(-0.4rem);
                    }
                    .slide-fade-enter-to,
                    .slide-fade-leave {
                        max-height: 10rem;
                    }
                    .news_right_bottom_none {
                        min-height: 3rem;
                        font-size: 0.3rem;
                        margin-bottom: 0.6rem;
                    }
                }
            }
        }
    }

}

</style>